import CallToActionBtn from './controls/CallToActionBtn'
import '../css/80sFloor.css'
import '../css/Hero.css'
// import spaceship from '../images/spaceship-sprite.gif'
// import sun from '../images/sun.png'
// import ufo from '../images/ufo-sprite.gif'
const Hero = ({ profile }) => {
  const { copy_text, first_name, last_name, resume_url } = profile
  const scrollToSelector = (e, selector) => {
    e.preventDefault()
    const el = document.querySelector(selector)
    if (el)
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      })
  }

  return (
    <section className='hero stars'>
      <img src='/static/images/site/spaceship-sprite.gif' alt='retro spaceship.' className='spaceship' loading='eager' decoding='async'></img>
      <img src='/static/images/site/sun.webp' alt='retro style sun rising.' className='sun' loading='eager' decoding='async'></img>
      <img src='/static/images/site/ufo-sprite.gif' alt='retro UFO.' className='ufo' loading='eager' decoding='async'></img>
      <h1 data-text={first_name} className='name first_name metal raise shine'>
        {first_name}
      </h1>
      <h1 data-text={last_name} className='name last_name metal raise shine'>
        {last_name}
      </h1>
      <div id='retrobg-ground'>
        <div id='retrobg-linesWrap'>
          <div id='retrobg-lines'>
            <div id='retrobg-vlines'>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>

              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
              <div className='retrobg-vline'></div>
            </div>
            <div id='retrobg-hlines'>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
              <div className='retrobg-hline'></div>
            </div>
          </div>
        </div>
        <div id='retrobg-groundShadow'></div>
      </div>

      <section className='section-intro-copy'>{copy_text}</section>
      <section className='section-cta'>
        {' '}
        <CallToActionBtn
          {...{
            text: 'RESUME',
            isHighlighted: false,
            to: resume_url,
          }}
        ></CallToActionBtn>
        <CallToActionBtn
          {...{
            text: 'WORK',
            isHighlighted: true,
            action: e => scrollToSelector(e, '#works'),
          }}
        ></CallToActionBtn>
        <CallToActionBtn
          {...{
            text: 'CONTACT',
            isHighlighted: false,
            action: e => scrollToSelector(e, '.contact'),
          }}
        ></CallToActionBtn>
      </section>
    </section>
  )
}

export default Hero
